import type React from 'react';

import { ResponseList } from './ResponseList';

export const ResponseListWrapper: React.FC = () => {
	return (
		<div className="mb-16">
			<ResponseList />
		</div>
	);
};
